module.exports = __webpack_public_path__ + "static/media/new-arrivals-black.7a1503cd.svg";